import { makeStyles } from "@material-ui/core";

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    "& .MuiDivider-root": {
      marginBottom: theme.spacing(4)
    }
  },
  drawerPaper: {
    width: drawerWidth,
    position: "fixed",
    top: theme.spacing(8),
    zIndex: "1"
  },
  content: {
    flexGrow: 1,
    boxSizing: "border-box",
    padding: theme.spacing(8),
    marginTop: theme.spacing(5),
    width: `calc( 100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth
  },
  titleSection: {
    marginBottom: "24px !important",
    marginTop: "32px !important",
    "& h4": {
      marginBottom: "16px !important"
    }
  },
  searchTitle: {
    marginBottom: theme.spacing(2)
  },
  createCompanyBtn: {
    // marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4)
  },
  companyTreeTitle: {
    marginBottom: theme.spacing(2)
  },
  companyTreeContent: {
    //padding: '24px !important',
    marginBottom: 0
  },
  treeOuter: {
    minHeight: 250,
    "& .ant-tree-checkbox-checked .ant-tree-checkbox-inner": {
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      "&:hover": {
        borderColor: theme.palette.primary.main
      }
    },
    "& .ant-tree .ant-tree-treenode .ant-tree-node-content-wrapper.ant-tree-node-selected":
      {
        color: theme.palette.primary.main,
        backgroundColor: "#eee"
      },
    "& .ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner::after": {
      backgroundColor: theme.palette.primary.main
    },
    "& .ant-tree-checkbox-wrapper:hover .ant-tree-checkbox-inner, & .ant-tree-checkbox:hover .ant-tree-checkbox-inner, & .ant-tree-checkbox-input:focus + .ant-tree-checkbox-inner":
      {
        borderColor: theme.palette.primary.main
      }
  },
  popupIndicatorOpen: {
    display: "none"
  },
  popupIndicator: {
    display: "none"
  },
  searchInput: {
    position: "relative",
    // width: '40vw !important',
    marginBottom: theme.spacing(2),
    "& .MuiFormControl-root": {
      width: "100% !important"
    }
  },
  searchIcon: {
    position: "absolute",
    top: 6,
    right: 12
  },
  clearIndicator: {
    right: 46
  },
  loading: {
    display: "block",
    margin: theme.spacing(8, "auto")
  }
}));

export default useStyles;
